import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import classes from './padlocksSearchBar.module.css'
import filters from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/filters2.png'
import exportIcon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/export.png'

// ── helpers ────────────────────────────────────────────────────

const Section = ({ label, badge, open, onToggle, children }) => (
  <div className={classes.section}>
    <div className={classes.sectionHeader} onClick={onToggle}>
      <div className={classes.sectionHeaderLeft}>
        <span className={classes.sectionLabel}>{label}</span>
        {badge > 0 && <span className={classes.badge}>{badge}</span>}
      </div>
      <span className={`${classes.chevron} ${open ? classes.chevronOpen : ''}`}>▼</span>
    </div>
    {open && <div className={classes.sectionBody}>{children}</div>}
  </div>
);

const Pills = ({ options, selected, onToggle }) => (
  <div className={classes.pills}>
    {options.map(opt => (
      <button
        key={opt}
        type="button"
        className={`${classes.pill} ${selected.includes(opt) ? classes.pillActive : ''}`}
        onClick={() => onToggle(opt)}
      >
        {opt}
      </button>
    ))}
  </div>
);

const CheckRow = ({ label, checked, onChange }) => (
  <label className={classes.checkRow}>
    <input type="checkbox" checked={checked} onChange={onChange} />
    {label}
  </label>
);

const GROUP_OPTIONS = (groups) => [
  { label: "— Not set —", value: "__UNSET__" },
  ...groups.map((group) => ({ label: group.name, value: group.name })).sort((a, b) => a.label.localeCompare(b.label))
];

// ── Component ──────────────────────────────────────────────────

const PadlocksSearchbar = (props) => {

    const { placeholder, onChange, value, handleFocus, handleBlur, setCategoryFilter, showFilterButton, reset, groups, selectedGroupFilter, setSelectedUsedByGroupFilter, setSelectedOwnedByGroupFilter, setSelectedBilledToGroupFilter, selectedCustomerBilledToGroupFilter, setSelectedCustomerBilledToGroupFilter, selectedFilter, setSelectedFilter, sortBy, setSortBy, portalSiteNameFilter, setPortalSiteNameFilter, includes, setIncludes, handleExport, unlinkedOnly, setUnlinkedOnly, isGateways, isSensors, isTankSensors, setBatteryFilter, setSignalFilter, setStatusFilter, sensorTypeFilter, setSensorTypeFilter} = props;
    const companyName = useSelector(state => state.auth.companyName);
    const isEyeSpyFX = companyName === "EyeSpyFX";
    const isRESURE = companyName === "RE:SURE";
    const [showFilters, setShowFilters] = useState(false);
    const [openSections, setOpenSections] = useState({});
    const [localSortBy, setLocalSortBy] = useState("")
    const [localSelectedFilter, setLocalSelectedFilter] = useState("")
    const [localSelectedBilledToGroupFilter, setLocalSelectedBilledToGroupFilter] = useState("")
    const [localSelectedCustomerBilledToGroupFilter, setLocalSelectedCustomerBilledToGroupFilter] = useState("")
    const [localSelectedOwnedByGroupFilter, setLocalSelectedOwnedByGroupFilter] = useState("")
    const [localSelectedUsedByGroupFilter, setLocalSelectedUsedByGroupFilter] = useState("")
    const [localIncludes, setLocalIncludes] = useState()
    const [localUnlinkedOnly, setLocalUnlinkedOnly] = useState(false)
    const [localPortalSiteNameFilter, setLocalPortalSiteNameFilter] = useState(portalSiteNameFilter)
    const [localStatus, setLocalStatus] = useState("")
    const [localBattery, setLocalBattery] = useState("")
    const [localSignal, setLocalSignal] = useState("")
    const [localSensorType, setLocalSensorType] = useState("")

    const [appliedFilters, setAppliedFilters] = useState({
        sortBy: sortBy || "",
        selectedFilter: selectedFilter || "",
        ownedBy: "",
        usedBy: "",
        billedTo: "",
        customerBilledTo: "",
        portalSiteName: portalSiteNameFilter || "",
        status: "",
        battery: "",
        signal: "",
        sensorType: sensorTypeFilter || "",
        unlinkedOnly: unlinkedOnly || false,
    });

    const chipLabel = (val) => val === "__UNSET__" ? "Not set" : val;

    const toggleSection = (key) =>
        setOpenSections(prev => ({ ...prev, [key]: !prev[key] }));

    const clearFilter = (key) => {
        setAppliedFilters(prev => ({ ...prev, [key]: key === 'unlinkedOnly' ? false : "" }));
        switch (key) {
            case 'sortBy':         setLocalSortBy(""); setSortBy(""); break;
            case 'selectedFilter': setLocalSelectedFilter(""); setSelectedFilter(""); break;
            case 'ownedBy':        setLocalSelectedOwnedByGroupFilter(""); setSelectedOwnedByGroupFilter(""); break;
            case 'usedBy':         setLocalSelectedUsedByGroupFilter(""); setSelectedUsedByGroupFilter(""); break;
            case 'billedTo':       setLocalSelectedBilledToGroupFilter(""); setSelectedBilledToGroupFilter(""); break;
            case 'customerBilledTo': setLocalSelectedCustomerBilledToGroupFilter(""); setSelectedCustomerBilledToGroupFilter(""); break;
            case 'portalSiteName': setLocalPortalSiteNameFilter(""); setPortalSiteNameFilter(""); break;
            case 'status':         setLocalStatus(""); setStatusFilter(""); break;
            case 'battery':        setLocalBattery(""); setBatteryFilter(""); break;
            case 'signal':         setLocalSignal(""); setSignalFilter(""); break;
            case 'sensorType':     setLocalSensorType(""); if (setSensorTypeFilter) setSensorTypeFilter(""); break;
            case 'unlinkedOnly':   setLocalUnlinkedOnly(false); setUnlinkedOnly(false); break;
            default: break;
        }
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
        }
    };

    const handleClear = () => {
        onChange({ target: { value: '' } });
    };

    const handleShowFilters = () => {
        setShowFilters(prev => !prev);
    };

    const HandleResetFilters = () => {
        setSelectedFilter("")
        setSortBy("")
        setSelectedOwnedByGroupFilter("")
        setSelectedUsedByGroupFilter("")
        setSelectedBilledToGroupFilter("")
        setSelectedCustomerBilledToGroupFilter("")
        setPortalSiteNameFilter("")
        setIncludes(true)
        setUnlinkedOnly(false)
        setStatusFilter("")
        setBatteryFilter("")
        setSignalFilter("")

        setLocalSelectedFilter("")
        setLocalSortBy([])
        setLocalSelectedBilledToGroupFilter([])
        setLocalSelectedCustomerBilledToGroupFilter([])
        setLocalSelectedOwnedByGroupFilter([])
        setLocalSelectedUsedByGroupFilter([])
        setLocalPortalSiteNameFilter("")
        setLocalIncludes(true)
        setLocalUnlinkedOnly(false)
        setLocalStatus("")
        setLocalBattery("")
        setLocalSignal("")
        setLocalSensorType("")
        if (setSensorTypeFilter) setSensorTypeFilter("")

        setAppliedFilters({ sortBy: "", selectedFilter: "", ownedBy: "", usedBy: "", billedTo: "", customerBilledTo: "", portalSiteName: "", status: "", battery: "", signal: "", sensorType: "", unlinkedOnly: false });

        setShowFilters(false)
    }


    useEffect(() => {
        if (reset > 0){
        HandleResetFilters()
        }
    }, [reset])

    const HandleApplyFilters = () => {
        setSelectedOwnedByGroupFilter(localSelectedOwnedByGroupFilter)
        setSelectedUsedByGroupFilter(localSelectedUsedByGroupFilter)
        setSelectedBilledToGroupFilter(localSelectedBilledToGroupFilter)
        setSelectedCustomerBilledToGroupFilter(localSelectedCustomerBilledToGroupFilter)
        setSelectedFilter(localSelectedFilter)
        setSortBy(localSortBy)
        setPortalSiteNameFilter(localPortalSiteNameFilter)
        setUnlinkedOnly(localUnlinkedOnly)
        setIncludes(localIncludes)
        setBatteryFilter(localBattery)
        setStatusFilter(localStatus)
        setSignalFilter(localSignal)
        if (setSensorTypeFilter) setSensorTypeFilter(localSensorType)

        setAppliedFilters({
            sortBy: localSortBy || "",
            selectedFilter: localSelectedFilter || "",
            ownedBy: localSelectedOwnedByGroupFilter || "",
            usedBy: localSelectedUsedByGroupFilter || "",
            billedTo: localSelectedBilledToGroupFilter || "",
            customerBilledTo: localSelectedCustomerBilledToGroupFilter || "",
            portalSiteName: localPortalSiteNameFilter || "",
            status: localStatus || "",
            battery: localBattery || "",
            signal: localSignal || "",
            sensorType: localSensorType || "",
            unlinkedOnly: localUnlinkedOnly || false,
        });

        setShowFilters(false)
    }

    const sorts = [
        "Billable",
        "Not billable"
    ]

    const options = [
        "Battery level asc",
        "Battery level desc",
        isGateways ? "Last seen (newest -> oldest)" : "Last read (newest -> oldest)",
        isGateways ? "Last seen (oldest -> newest)" : "Last read (oldest -> newest)",
        ...(isTankSensors ? [] : [
            isGateways ? "Date added (newest -> oldest)" : "Registered (newest -> oldest)",
            isGateways ? "Date added (oldest -> newest)" : "Registered (oldest -> newest)",
            "Owner A-Z",
            "Owner Z-A",
            "Billed to A-Z",
            "Billed to Z-A",
            "Used by A-Z",
            "Used by Z-A"
        ])
    ]

    const statusOptions = [
        "Online",
        "Offline",
        "Missed check-in"
    ]

    const batteryOptions = [
        "Low battery",
        "Warning",
        "Healthy"
    ]

    const signalOptions = [
        "Poor",
        "Fair",
        "Good"
    ]

    const sensorTypeOptions = [
        "SigFox lite contact",
        "SigFox industrial contact",
        "Standalone NB-IOT Sensor",
        "BLE Sensor"
    ]

    const handleUnlinked = () => {
        setLocalUnlinkedOnly(!localUnlinkedOnly)
    }

    const activeChips = [
        appliedFilters.sortBy         && { key: 'sortBy',         label: `Sort: ${appliedFilters.sortBy}` },
        appliedFilters.selectedFilter && { key: 'selectedFilter', label: `Billing: ${appliedFilters.selectedFilter}` },
        appliedFilters.status         && { key: 'status',         label: `Status: ${appliedFilters.status}` },
        appliedFilters.battery        && { key: 'battery',        label: `Battery: ${appliedFilters.battery}` },
        appliedFilters.signal         && { key: 'signal',         label: `Signal: ${appliedFilters.signal}` },
        appliedFilters.sensorType     && { key: 'sensorType',     label: `Sensor type: ${appliedFilters.sensorType}` },
        appliedFilters.ownedBy        && { key: 'ownedBy',        label: `Owned by: ${chipLabel(appliedFilters.ownedBy)}` },
        appliedFilters.usedBy         && { key: 'usedBy',         label: `Used by: ${chipLabel(appliedFilters.usedBy)}` },
        appliedFilters.billedTo       && { key: 'billedTo',       label: `Inniovate bill to: ${chipLabel(appliedFilters.billedTo)}` },
        appliedFilters.customerBilledTo && { key: 'customerBilledTo', label: `RE:SURE bill to: ${chipLabel(appliedFilters.customerBilledTo)}` },
        appliedFilters.portalSiteName && { key: 'portalSiteName', label: `Site name: ${appliedFilters.portalSiteName}` },
        appliedFilters.unlinkedOnly   && { key: 'unlinkedOnly',   label: 'Unlinked only' },
    ].filter(Boolean);

    // ── badge counts ────────────────────────────────────────────
    const sortBadge = localSortBy ? 1 : 0;
    const statusBadge = (localStatus ? 1 : 0) + (localBattery ? 1 : 0) + (localSignal ? 1 : 0);
    const sensorTypeBadge = localSensorType ? 1 : 0;
    const billingBadge = (localSelectedFilter ? 1 : 0) + (localSelectedOwnedByGroupFilter ? 1 : 0) + (localSelectedUsedByGroupFilter ? 1 : 0) + (localSelectedFilter !== "Not billable" && localSelectedBilledToGroupFilter ? 1 : 0) + (localSelectedFilter !== "Not billable" && localSelectedCustomerBilledToGroupFilter ? 1 : 0);
    const linkingBadge = localUnlinkedOnly ? 1 : 0;

    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
      <div className={classes.searchContainer}>
          <input
              className={classes.searchBar}
              placeholder={placeholder}
              value={value}
              onKeyPress={handleKeyPress}
              onChange={onChange}
              onFocus={handleFocus}
              onBlur={handleBlur}
              spellCheck={false}
          />

          <div className={classes.buttonGroup}>
              {value && (
                  <button className={classes.clearButton} onClick={handleClear} type="button">
                      ×
                  </button>
              )}
              {showFilterButton && (
                  <button className={classes.filterButton} onClick={handleShowFilters} type="button">
                      <img style={{ height: 30, width: 30 }} src={filters} />
                  </button>
              )}
              <button className={classes.filterButton} onClick={handleExport} type="button">
                  <img style={{ height: 30, width: 30 }} src={exportIcon} />
              </button>
          </div>

          {showFilters && (
                <div className={classes.panel}>
                    <div className={classes.panelHeader}>
                        <span className={classes.panelTitle}>Filters</span>
                        <div className={classes.panelActions}>
                            <button className={classes.resetBtn} type="button" onClick={HandleResetFilters}>Reset</button>
                            <button className={classes.applyBtn} type="button" onClick={HandleApplyFilters}>Apply</button>
                        </div>
                    </div>

                    <div className={classes.panelBody}>

                        {/* Sort */}
                        <Section label="Sort" badge={sortBadge} open={openSections.sort} onToggle={() => toggleSection('sort')}>
                            <div className={classes.sortGrid}>
                                {options.map(opt => (
                                    <button
                                        key={opt}
                                        type="button"
                                        className={`${classes.sortPill} ${localSortBy === opt ? classes.sortPillActive : ''}`}
                                        onClick={() => setLocalSortBy(localSortBy === opt ? "" : opt)}
                                    >
                                        {opt}
                                    </button>
                                ))}
                            </div>
                        </Section>

                        {/* Status / Battery / Signal - gateways only */}
                        {isGateways && (
                            <Section label="Status" badge={statusBadge} open={openSections.status} onToggle={() => toggleSection('status')}>
                                <div className={classes.subSection}>
                                    <span className={classes.subLabel}>Connectivity</span>
                                    <Pills
                                        options={statusOptions}
                                        selected={localStatus ? [localStatus] : []}
                                        onToggle={v => setLocalStatus(localStatus === v ? "" : v)}
                                    />
                                </div>
                                <div className={classes.subSection}>
                                    <span className={classes.subLabel}>Battery level</span>
                                    <Pills
                                        options={batteryOptions}
                                        selected={localBattery ? [localBattery] : []}
                                        onToggle={v => setLocalBattery(localBattery === v ? "" : v)}
                                    />
                                </div>
                                <div className={classes.subSection}>
                                    <span className={classes.subLabel}>Signal strength</span>
                                    <Pills
                                        options={signalOptions}
                                        selected={localSignal ? [localSignal] : []}
                                        onToggle={v => setLocalSignal(localSignal === v ? "" : v)}
                                    />
                                </div>
                            </Section>
                        )}

                        {/* Sensor type - sensors only */}
                        {isSensors && (
                            <Section label="Sensor type" badge={sensorTypeBadge} open={openSections.sensorType} onToggle={() => toggleSection('sensorType')}>
                                <Pills
                                    options={sensorTypeOptions}
                                    selected={localSensorType ? [localSensorType] : []}
                                    onToggle={v => setLocalSensorType(localSensorType === v ? "" : v)}
                                />
                            </Section>
                        )}

                        {/* Billing - not applicable to tank sensors, which have no ownership/billing model */}
                        {!isTankSensors && (
                        <Section label="Billing" badge={billingBadge} open={openSections.billing} onToggle={() => toggleSection('billing')}>
                            <div className={classes.subSection}>
                                <span className={classes.subLabel}>Billing status</span>
                                <Pills
                                    options={sorts}
                                    selected={localSelectedFilter ? [localSelectedFilter] : []}
                                    onToggle={v => setLocalSelectedFilter(localSelectedFilter === v ? "" : v)}
                                />
                            </div>
                            <div className={classes.fieldRow}>
                                <span className={classes.fieldLabel}>Owned by</span>
                                <select
                                    className={classes.nativeSelect}
                                    value={localSelectedOwnedByGroupFilter}
                                    onChange={e => setLocalSelectedOwnedByGroupFilter(e.target.value)}
                                >
                                    <option value="">Any group</option>
                                    {GROUP_OPTIONS(groups).map(({ label, value }) => (
                                        <option key={value} value={value}>{label}</option>
                                    ))}
                                </select>
                            </div>
                            <div className={classes.fieldRow}>
                                <span className={classes.fieldLabel}>Used by</span>
                                <select
                                    className={classes.nativeSelect}
                                    value={localSelectedUsedByGroupFilter}
                                    onChange={e => setLocalSelectedUsedByGroupFilter(e.target.value)}
                                >
                                    <option value="">Any group</option>
                                    {GROUP_OPTIONS(groups).map(({ label, value }) => (
                                        <option key={value} value={value}>{label}</option>
                                    ))}
                                </select>
                            </div>
                            {isEyeSpyFX && localSelectedFilter !== "Not billable" && (
                                <div className={classes.fieldRow}>
                                    <span className={classes.fieldLabel}>Inniovate bill to</span>
                                    <select
                                        className={classes.nativeSelect}
                                        value={localSelectedBilledToGroupFilter}
                                        onChange={e => setLocalSelectedBilledToGroupFilter(e.target.value)}
                                    >
                                        <option value="">Any group</option>
                                        {GROUP_OPTIONS(groups).map(({ label, value }) => (
                                            <option key={value} value={value}>{label}</option>
                                        ))}
                                    </select>
                                </div>
                            )}
                            {(isEyeSpyFX || isRESURE) && localSelectedFilter !== "Not billable" && (
                                <div className={classes.fieldRow}>
                                    <span className={classes.fieldLabel}>RE:SURE bill to</span>
                                    <select
                                        className={classes.nativeSelect}
                                        value={localSelectedCustomerBilledToGroupFilter}
                                        onChange={e => setLocalSelectedCustomerBilledToGroupFilter(e.target.value)}
                                    >
                                        <option value="">Any group</option>
                                        {GROUP_OPTIONS(groups).map(({ label, value }) => (
                                            <option key={value} value={value}>{label}</option>
                                        ))}
                                    </select>
                                </div>
                            )}
                        </Section>
                        )}

                        {/* Details */}
                        <Section label="Details" badge={localPortalSiteNameFilter ? 1 : 0} open={openSections.details} onToggle={() => toggleSection('details')}>
                            <div className={classes.fieldRow}>
                                <span className={classes.fieldLabel}>Portal name contains</span>
                                <input
                                    className={classes.textInput}
                                    placeholder="Enter keyword..."
                                    value={localPortalSiteNameFilter || ''}
                                    onChange={e => setLocalPortalSiteNameFilter(e.target.value)}
                                />
                            </div>
                        </Section>

                        {/* Linking - non-gateways, non-tank-sensors only */}
                        {!isGateways && !isTankSensors && (
                            <Section label="Linking" badge={linkingBadge} open={openSections.linking} onToggle={() => toggleSection('linking')}>
                                <CheckRow
                                    label="Show unlinked padlocks only"
                                    checked={localUnlinkedOnly === true}
                                    onChange={handleUnlinked}
                                />
                            </Section>
                        )}

                    </div>
                </div>
            )}
      </div>
      {activeChips.length > 0 && (
          <div className={classes.activeFilters}>
              {activeChips.map(({ key, label }) => (
                  <span key={key} className={classes.filterChip}>
                      {label}
                      <button className={classes.filterChipClear} onClick={() => clearFilter(key)} type="button">×</button>
                  </span>
              ))}
          </div>
      )}
      </div>
    );
}

export default PadlocksSearchbar;
